define((require) => {
    "use strict";

    const TemplateSorting = require("ui/dashboard/TemplateSorting");
    const EditorEvents     = require("shared/services/EditorEvents");
    const ImprovedView     = require("editor/zbone/ImprovedView");
    const {isBlank, trim}  = require("shared/util/StringUtils");
    const template         = require("ui/dashboard/TemplateSortingPanel.tpl");

    /**
     * View displaying the sorting options and the search input for the dashboard.
     *
     * @class TemplateSortingPanel
     */
    return ImprovedView.extend({

        template: template,

        className: "sorting-panel",

        events: {
            "click @ui.sortingElements": "_sortClickHandler",

            "keyup @ui.searchInput": "_searchKeyupHandler"
        },

        ui: {
            sortingElements: "[data-sort]",
            searchInput: ".content-filtering"
        },

        /**
         * @type {TemplateSorting}
         */
        _sorting: null,

        _searching: false,

        _searchPhase: "",

        initialize: function() {
            this._sorting = TemplateSorting.current();
        },

        getSorting: function() {
            return this._sorting;
        },

        setSorting: function(sorting) {
            this.ui.sortingElements.hide();
            this.ui.sortingElements.removeClass("active");
            this.$el.find("[data-sort='" + sorting.value + "']").addClass("active");

            this._sorting = sorting;

            TemplateSorting.set(sorting);

            if (this._searching) {
                this.trigger("search", this._searchPhase, sorting);
            } else {
                this.trigger("sort", sorting);
            }
        },

        isSearching: function() {
            return this._searching;
        },

        getSearchPhase: function() {
            return this._searchPhase;
        },

        disable: function(value) {
            this.$el.toggleClass("disabled", value === true || value === undefined);
        },

        onRender: function() {
            this.setSorting(this._sorting);
        },

        _triggerSearch: function(searchPhase) {
            if (searchPhase === this._searchPhase) {
                return;
            }
            // If user clears the input field, reset to current sorting.
            if (isBlank(searchPhase)) {
                this._resetSearchState();
                this.setSorting(this._sorting);
                return;
            }

            this._searchPhase = searchPhase;
            this._searching = true;

            // Signal that we're searching...
            this.trigger("search", searchPhase, this._sorting);
        },

        _searchKeyupHandler: function(event) {
            const searchPhase = trim(event.target.value);

            this._triggerSearch(searchPhase);
        },

        _sortClickHandler: function(event) {
            const sorting = event.target.getAttribute("data-sort");

            if (sorting === this._sorting.value && !this._searching) {
                return;
            }

            this.setSorting(TemplateSorting.fromValue(sorting));

            const eventProperties = {
                sortBy: sorting,
                triggerOrigin: "SortingPanel"
            };

            EditorEvents.trigger(EditorEvents.constants.SORT_TEMPLATE, eventProperties);
        },

        _resetSearchState: function() {
            this.ui.searchInput.val("");
            this._searching = false;
            this._searchPhase = "";
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/dashboard/TemplateSortingPanel.js